import { useEffect } from "react";

/**
 * useHelpFocusBlur
 * Adds focus/blur event listeners to all inputs/selects/textareas with data-id inside containerRef,
 * and highlights the corresponding help card in the help menu when focused.
 * @param {React.RefObject} containerRef - ref to the container element
 * @param {Function} setHelperAtom - jotai setter for helpAtom
 * @param {Object} helperAtom - jotai atom value for helpAtom
 */
export function useHelpFocusBlur(containerRef, setHelperAtom, helperAtom) {
  useEffect(() => {
    if (!containerRef.current) return;
    const inputElements = containerRef.current.querySelectorAll(
      "input, select, textarea, file, [data-id]"
    );
    function handleFocus(event) {
      const dataId = event.target.getAttribute("data-id");
      if (dataId) {
        const cardElement = document.querySelector(`[card-id="${dataId}"]`);
        if (cardElement) {
          cardElement.scrollIntoView({ behavior: "smooth", block: "center" });
          cardElement.style.transition = "background-color 0.5s ease";
          cardElement.style.border = "2px solid #42b4e6";
          setTimeout(() => {
            cardElement.style.border = "";
          }, 2000);
        }
      }
    }
    function handleBlur(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setHelperAtom({
          ...helperAtom,
          isFocused: false,
          helpSection: {
            title: "",
            description: "",
            type: "",
            other: "",
          },
        });
      }
    }
    inputElements.forEach((inputElement) => {
      inputElement.addEventListener("focus", handleFocus);
      inputElement.addEventListener("blur", handleBlur);
    });
    return () => {
      inputElements.forEach((inputElement) => {
        inputElement.removeEventListener("focus", handleFocus);
        inputElement.removeEventListener("blur", handleBlur);
      });
    };
  }, [helperAtom, containerRef, setHelperAtom]);
}
